export default "__VITE_ASSET__DDT42kGm__"